class StorageWrapper {
	constructor(private readonly storage?: Storage) {
	}

	read(key: string) {
		if (this.storage) {
			try {
				return this.storage.getItem(key) || undefined;
			}
			catch (error) {
				// for porn mode
				console.error("Could not read from storage", error);
			}
		}
		return undefined;
	}

	write(key: string, value: string) {
		if (this.storage) {
			try {
				return localStorage.setItem(key, value);
			}
			catch (error) {
				// for porn mode
				console.error("Could not write to storage", error);
			}
		}
	}

	remove(key: string) {
		if (this.storage) {
			try {
				localStorage.removeItem(key);
			}
			catch (error) {
				// for porn mode
				console.error("Could not remove from storage", error);
			}
		}
	}

	readJson<T>(key: string): T | undefined {
		const value = this.read(key);
		if (value) {
			try {
				return JSON.parse(value) as T;
			}
			catch (error) {
				// ignored, return undefined
			}
		}
		return undefined;
	}

	writeJson<T>(key: string, value: T) {
		this.write(key, JSON.stringify(value));
	}

	onChange(key: string, handler: (e: StorageEvent) => void) {
		if (this.storage) {
			window.addEventListener("storage", e => {
				if (e.storageArea == this.storage && e.key == key) {
					handler(e);
				}
			});
		}
	}
}

export const safeLocalStorage = new StorageWrapper(window.localStorage);
